<template>
  <div class="header-container">
    <div class="header">
      <div class="header-title-container">
        <div class="header-title-logo" />
        <!-- <div class="header-title">泰山数据要素产业园</div>
      <div class="header-desc">山东数字经济研究基地</div> -->
        <!-- <div class="header-desc">
          <i class="el-icon-caret-bottom" />
          <span>山东区域</span>
        </div> -->
      </div>
      <div class="header-menu-container">
        <!-- <div class="active-line" ref="activeLine"></div> -->
        <div
          class="menu-item"
          v-for="(item, index) in menuList"
          :key="item.path"
          ref="menuItem"
          @click="delayMenuClick($event, item.path)"
        >
          <div
            class="menu-item-title"
            :class="{
              'menu-item-title-active': isMenuActive(item),
            }"
          >
            {{ item.title }}
          </div>
          <div class="menu-item-children" v-if="item.children">
            <div
              class="menu-item-child"
              v-for="child in item.children"
              :key="child.path"
              @click="delayMenuClick($event, child.path)"
              :class="{
                'menu-item-child-active': $route.fullPath.includes(child.path),
              }"
            >
              {{ child.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="header-action">
        <RightContent></RightContent>
      </div>
    </div>
  </div>
</template>
<script>
import RightContent from "../RightContent";
import _ from "lodash";
import { menuData } from "./config";

export default {
  name: "CusHeader",
  components: {
    RightContent,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    categoryMap: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      menuList: menuData,
    };
  },
  mounted() {
    this.handleActiveChange();
    window.addEventListener("resize", this.handleActiveChange);
  },
  watch: {
    "$route.fullPath"() {
      this.handleActiveChange();
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleActiveChange);
  },
  methods: {
    /* 800ms内点击立马执行一次，且800ms最多执行一次 */
    delayMenuClick: _.throttle(
      function (e, path) {
        this.handleMenuClick(e, path);
      },
      800,
      { leading: true, trailing: false }
    ),
    handleMenuClick(e, path) {
      console.log(path);
      e.stopPropagation();
      if (path === this.$route.fullPath || this.$route.fullPath.includes(path))
        return;
      if (
        this.categoryMap[path] &&
        this.categoryMap[path].catalogType === "link" &&
        this.categoryMap[path].redirectUrl
      ) {
        window.open(this.categoryMap[path].redirectUrl, "_blank");
      } else {
        if (path && path != "/sjjypt" && path != "/cjgc" && path != "/gywm") {
          this.$router.push(path);
        }
      }
    },
    handleActiveChange() {
      this.$nextTick(() => {
        if (this.$refs.menuItem.length === 0) return;
        /* baseLeft 是第一个元素对父元素的左侧距离  */
        // const baseLeft = this.$refs.menuItem[0].offsetLeft;
        // const activeIndex = this.menuList.findIndex((item) => {
        //   let path = item.path;
        //   if (item.path === "/home/index") {
        //     path = "/home";
        //   }
        //   return this.$route.fullPath.includes(path);
        // });
        // if (activeIndex === -1) {
        //   this.$refs.activeLine.style.left = "-195px";
        //   this.$refs.activeLine.style.width = "68px";
        //   this.$refs.activeLine.style.borderRadius = "50%";
        //   return;
        // }
        // this.$refs.activeLine.style.borderRadius = "0";
        // this.$refs.activeLine.style.height = "3px";
        // const activeItem = this.$refs.menuItem[activeIndex];
        // const sumWidth = this.menuList.reduce((sum, item, index) => {
        //   if (index < activeIndex) {
        //     sum += this.$refs.menuItem[index].offsetWidth;
        //   }
        //   return sum;
        // }, 0);
        // this.$refs.activeLine.style.left = `${
        //   baseLeft + sumWidth + 40 * activeIndex
        // }px`;
        // this.$refs.activeLine.style.width = `${activeItem.offsetWidth}px`;
      });
    },
    isMenuActive(item) {
      // 检查当前路由是否匹配父级菜单
      if (this.$route.fullPath.includes(item.path)) {
        return true;
      }
      // 检查当前路由是否匹配子菜单
      if (item.children && item.children.length > 0) {
        return item.children.some((child) =>
          this.$route.fullPath.includes(child.path)
        );
      }
      return false;
    },
  },
};
</script>
<style lang="less" scoped>
.header-container {
  width: 100%;
  height: 64px;
  background-color: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.05);
}
.header {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 1200px;
  height: 60px;
  margin: 0 auto;
  background-color: #fff;
  .header-title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 255px;
    padding-left: 4px;
    font-size: 12px;
    user-select: none;

    gap: 4px;
    .header-title-logo {
      flex-shrink: 1;
      width: 201px;
      height: 26px;
      background-image: url("@/assets/tslogo.png");
      background-repeat: no-repeat;
      background-size: contain;
    }
    // .header-title {
    //   height: 14px;
    //   color: #000000;
    //   font-size: 14px;
    //   font-weight: 500;
    //   line-height: 14px;
    // }
    .header-desc {
      display: flex;
      align-items: center;
      color: #409eff;
      span {
        margin-left: 4px;
      }
    }
  }
  .header-menu-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    // overflow-x: auto;
    flex-shrink: 0;
    height: 60px;
    user-select: none;

    gap: 5px;
    .menu-item {
      position: relative;
      flex-shrink: 0;
      height: 36px;
      color: #666;
      font-size: 14px;
      font-weight: 400;
      line-height: 36px;
      cursor: pointer;
      .menu-item-children {
        position: absolute;
        top: 100%;
        left: -5px;
        flex-direction: column;
        box-sizing: border-box;
        overflow: hidden;
        height: 0;
        text-align: center;
        background-color: #fff;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
        border-radius: 3px;
        transition: all 0.3s;
        .menu-item-child {
          display: flex;
          justify-content: center;
          box-sizing: border-box;
          width: max-content;
          min-width: 104px;
          height: 32px;
          height: 32px;
          padding: 0 10px;
          color: #666;
          font-size: 14px;
          font-weight: 400;
          line-height: 32px;
          background: #fff;
          cursor: pointer;
        }
        .menu-item-child:hover {
          color: #0079f3;
        }
        .menu-item-child-active {
          display: flex;
          justify-content: center;
          //width: 100%;
          min-width: 104px;
          height: 32px;
          color: #0079f3;
          background: #edf6ff;
        }
      }
      &:hover {
        .menu-item-children {
          height: max-content;
          padding: 4px 0;
        }
      }
    }
    .menu-item-title {
      padding: 0 14px;
      border-radius: 10px;
    }

    .menu-item-title-active {
      position: relative;
      color: #fff;
      background: #000;
      cursor: pointer;

      // &::after {
      //   content: "";
      //   position: absolute;
      //   bottom: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 3px;
      //   background-color: #0079f3;
      // }
    }
    // .active-line {
    //   position: absolute;
    //   bottom: 0;
    //   height: 3px;
    //   background-color: #0079f3;
    //   transition: all 0.3s;
    // }
  }
  .header-action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 170px;
  }
}
</style>
